import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

//components
import PdpSharedBlurbTradeLoyalty from './PdpSharedBlurbTradeLoyalty';
import PdpSharedBlurbBuyerProtection from './PdpSharedBlurbBuyerProtection';

//helpers
import get from 'lodash.get';

export function PdpSharedProtectionOrLoyalty({ isClient = true, item, user, viewer }) {
    if (!isClient) {
        return null;
    }

    const showTrade =
        get(user, 'isVerifiedTrade') &&
        !get(user, 'tradeFirm.loyalty.isBlacklisted') &&
        (get(item, 'isArt') || get(item, 'isFurniture'));

    return showTrade ? (
        <PdpSharedBlurbTradeLoyalty user={user} viewer={viewer} />
    ) : (
        <PdpSharedBlurbBuyerProtection />
    );
}

PdpSharedProtectionOrLoyalty.propTypes = {
    item: PropTypes.object,
    isClient: PropTypes.bool,
    user: PropTypes.object,
    viewer: PropTypes.object,
};

export default createFragmentContainer(PdpSharedProtectionOrLoyalty, {
    item: graphql`
        fragment PdpSharedProtectionOrLoyalty_item on Item {
            isArt
            isFurniture
        }
    `,
    user: graphql`
        fragment PdpSharedProtectionOrLoyalty_user on User {
            isVerifiedTrade
            ...PdpSharedBlurbTradeLoyalty_user
            tradeFirm {
                loyalty {
                    isBlacklisted
                }
            }
        }
    `,
});
